import { useEffect } from "react";
import usePagination from "./usePagination";
import { indexSegments } from "api/main/segments";
import { ISegment, ISegmentIndexParams } from "models/Segmet";

const useSegments = ({
    project_id,
    pageSize: defaultPageSize
}: ISegmentIndexParams): ReturnType<typeof usePagination<ISegment>> => {

    const hookSegments = usePagination<ISegment>({ pageSize: defaultPageSize });
    const { page, pageSize } = hookSegments;

    useEffect(() => {
        const getSegments = async () => {
            hookSegments.loadingStart();
            const { data, totalItems }: { data: ISegment[], totalItems: number } = await indexSegments({
                project_id,
            });
            hookSegments.setData(data);
            hookSegments.setTotalItems(totalItems)
            hookSegments.loadingEnd();
        }
        getSegments();
    }, [page, pageSize, project_id]);

    return hookSegments;
}

export default useSegments;